// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608121348/js/" + chunkId + "." + {"44":"11eb0c20","225":"e1892ae8","481":"5211d261","486":"e55c60d4","770":"2cb6cd87"}[chunkId] + ".0.491524494856327.chunk.js";
};